import { render, staticRenderFns } from "./AddIncidentSidebar.vue?vue&type=template&id=fd484f4a&scoped=true&"
import script from "./AddIncidentSidebar.vue?vue&type=script&lang=js&"
export * from "./AddIncidentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddIncidentSidebar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddIncidentSidebar.vue?vue&type=style&index=1&id=fd484f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd484f4a",
  null
  
)

export default component.exports